import { Glass, OperationType } from './../dossier';

export type FitterSlotAvailabilityMode = 'DELAY' | 'CUT_OFF';

export interface FitterSlotAvailability {
  mode?: FitterSlotAvailabilityMode;
  cutOffs?: {
    morning?: string;
    afternoon?: string;
  };
}

export interface FitterServiceType {
  id?: string;
  name: string;
  operationType: OperationType;
  glassType: Glass;
  interventionDuration: number;
  interventionDurationMobility?: number;
  color: string;
  canBookOnline: boolean;
  canMakeOutsideIntervention: boolean;
  canMakeInCenterIntervention: boolean;
  canShareReplacementVehicle: boolean;
  active: boolean;
  default: boolean;
  offSet: number;
  mobilityOffSet?: number;
  weekendOffset: FitterweekendOffset;
  calibration: boolean;
  slotAvailability?: FitterSlotAvailability;
}

export interface FitterweekendOffset {
  isActive: boolean;
  offSet?: number;
  startDay?: number;
  startHour?: string;
  endDay?: number;
  endHour?: string;
}

export interface FitterServiceTypeSearch {
  id?: string;
  operationType: OperationType;
  glassType: Glass;
  isBookedOnline?: boolean;
  isMobility?: boolean;
  replacementVehicle?: boolean;
  active?: boolean;
  default?: boolean;
  calibration?: boolean;
  offSet?: number;
  mobilityOffSet?: number;
}
